import { IFramePlayerAbstractClass } from 'iframe/ts/player/abstract/IFramePlayerAbstractClass';
export class PinGateNamespace extends IFramePlayerAbstractClass {
    constructor(iframePlayer) {
        super(iframePlayer, 'PinGateNamespace');
    }
}
